import { render, staticRenderFns } from "./SideUserDetail.vue?vue&type=template&id=bf38c7c0&scoped=true"
import script from "./SideUserDetail.vue?vue&type=script&lang=js"
export * from "./SideUserDetail.vue?vue&type=script&lang=js"
import style0 from "./SideUserDetail.vue?vue&type=style&index=0&id=bf38c7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf38c7c0",
  null
  
)

export default component.exports